export const bulletListToArray = (text: string): string[] => {
  if (!text) return [];

  return text
    .split("●")
    .map((x) => x.trim())
    .filter((x) => x);
};

export const checkIfDecimal = (value: number) => {
  const hasDecimal = value - Math.floor(value) !== 0;
  return hasDecimal === true ? value.toFixed(2) : value;
};
